<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
  <div [innerHTML]="content"></div>
</div>
<div mat-dialog-actions>
  <button
    mat-button
    type="button"
    [disabled]="isBlockOkButton"


    *ngIf="!isAlert"
    (click)="onOkClick()"
  >
    {{ okButtonText }}
  </button>
  <button mat-button type="button" cdkFocusInitial (click)="onNoOkClick()">
    {{ noOkButtonText }}
  </button>
</div>
